import React from 'react';
import { IconSpinner, IconCircle, IconCircleCheck, IconCircleXmark } from '../ui-kit/icons';
import { Tooltip, OverlayTrigger } from '../ui-kit';

const tooltip = available => {
  const tooltipMessage = I18n.t(available ? 'available' : 'not_available');

  return (
    <Tooltip id="tooltip">
      <strong>{tooltipMessage}</strong>
    </Tooltip>
  );
};

const colors = {
  'available standby-duty': '#5959fc',
  available: '#00bb00',
  unavailable: '#da4f49'
};

const AvailabilityIcon = ({ available, standbyDuty, withIcon = false }) => {
  // if undefined, show a loader
  if (available === undefined) return <IconSpinner spin />;

  let availableClass = available ? 'available' : 'unavailable';
  if (standbyDuty) availableClass += ' standby-duty';

  const IconType = withIcon ? (available ? IconCircleCheck : IconCircleXmark) : IconCircle;

  return (
    <OverlayTrigger placement="right" overlay={tooltip(available)}>
      <IconType style={{ color: colors[availableClass] }} className={availableClass} />
    </OverlayTrigger>
  );
};

export default AvailabilityIcon;
